import { atom } from 'jotai';
import { IS_DEV_ENV } from '@/constants/env';

/**
 * This is a global state that contains the active adhoc recording's speech OTID, if any.
 * The atom will be updated by Adhoc Recorder. Other components should only read this atom,
 * but should never modify it.
 */
export const adhocRecordingSpeechOtidAtom = atom<string | null>(null);

if (IS_DEV_ENV) {
  adhocRecordingSpeechOtidAtom.debugLabel = 'adhocRecordingSpeechOtidAtom';
}
